import ContactType from "enums/ContactType";

interface ContactLike {
  contactType?: string | null;
  parentContactId?: string | null;
}

/**
 * An individual under a business. A payment goes to the business, so this
 * contact is never a payee, and picking one resolves to its parent instead.
 */
export const isChildContact = <T extends ContactLike>(
  contact: T,
): contact is T & { parentContactId: string } =>
  contact.contactType === ContactType.Individual && !!contact.parentContactId;
